export default __webpack_public_path__ + "static/media/serviceTypeImage1.017d4de1.svg";